import { useEffect, useState, useCallback } from 'react';
import { supabase} from '../../configs/supabase';
import { useAuthContext } from '../auth/AuthContext';
import { Customer } from '../types/customer';
import { DataFetchError } from '../../utils/ErrorClass';

const useCustomer = () => {
  const { state } = useAuthContext();
  const [customer, setCustomer] = useState<Customer>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomer = useCallback(async () => {
    try {
      if (state.customerId !== -1) {
        const { data, error } = await supabase
          .from('customer')
          .select('*')
          .eq('id', state.customerId)
          .maybeSingle();

        if (error) {
          throw new DataFetchError('Error fetching customer');
        } else if (!data) {
          throw new DataFetchError('Customer not found');
        } else {
          setCustomer(data as Customer);
        }
      }
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [state.customerId]);

  useEffect(() => {
    fetchCustomer();
  }, [fetchCustomer]);

  return { customer, loading, error };
};

export default useCustomer;
